import dynamic from 'next/dynamic';

import ElementContent from '@/components/sections/builder/elements/body/slideshow/content';
const ElementSetting = dynamic(
  () =>
    import('@/components/sections/builder/elements/body/slideshow/setting').then(
      (mod) => mod.default
    ),
  { ssr: false }
);

import { ElementDataType } from './types';
import Slide from '@/components/sections/builder/elements/body/slideshow/slide';
import { Images } from 'lucide-react';

export const SlideComponent = Slide;

export const defaultData: ElementDataType = {
  name: 'Slideshow',
  contentName: 'Slideshow',
  layout: 'full',
  slideHeight: 'adapt',
  animation: 'none',
  paginationStyle: 'counter',
  paginationPosition: 'bottom',
  paginationAlignment: 'center',
  changeSlidesEvery: 5,
  showContentBelowImagesOnMobile: false,
  autoplay: false,
  ratio: '16/9',
  hidePagination: true,
  data: [
    {
      name: 'Slide',
      img: '/assets/temporary-banner.png',
      heading: 'Image slide',
      subheading: `Tell your brand's story through images`,
      buttonLabel: 'Button label',
      buttonLink: '#',
      headingSize: '30',
      isOutlineButton: false,
      desktopContentPosition: 'middleCenter',
      desktopContentAlignment: 'center',
      imgOverlayOpacity: 0,
      colorSchemeBackround: 'background1',
      mobileLayout: 'center',
      mobileMinWidth: 720,
    },
    {
      name: 'Slide',
      img: '/assets/temporary-banner.png',
      heading: 'Image slide 2',
      subheading: `Tell your brand's story through images`,
      buttonLabel: 'Button label',
      buttonLink: '#',
      headingSize: '30',
      isOutlineButton: false,
      desktopContentPosition: 'middleCenter',
      desktopContentAlignment: 'center',
      imgOverlayOpacity: 0,
      colorSchemeBackround: 'background1',
      mobileLayout: 'center',
      mobileMinWidth: 720,
    },
  ],
};

export const ElementPreviewIcon = Images;

const Slideshow = {
  type: 'slideshow',
  group: 'body',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  defaultChilds: [Slide],
  childs: [Slide],
};

export default Slideshow;
